import { SparklesIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@/components/ui/empty';

interface EmptyImprovementsProps {
  /**
   * `waiting`: the brain has no improvements at all — Omni hasn't produced any
   * yet. `caught_up`: the current status filter has nothing left to review.
   */
  variant: 'waiting' | 'caught_up';
  /**
   * Per-brain toggle state. Only affects the `waiting` variant: enabled shows
   * "Omni is analyzing" copy, disabled prompts to turn the toggle on.
   */
  improvementsEnabled?: boolean;
}

export const EmptyImprovements = ({
  variant,
  improvementsEnabled = true,
}: EmptyImprovementsProps) => {
  const { t } = useTranslation();

  const getTitleKey = () => {
    if (variant === 'caught_up') {
      return 'improvements.caught_up_title';
    }
    return improvementsEnabled ? 'improvements.waiting_title' : 'improvements.disabled_title';
  };

  const getDescriptionKey = () => {
    if (variant === 'caught_up') {
      return 'improvements.caught_up_description';
    }
    return improvementsEnabled
      ? 'improvements.waiting_description'
      : 'improvements.disabled_description';
  };

  return (
    <Empty>
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <SparklesIcon aria-hidden />
        </EmptyMedia>
        <EmptyTitle>{t(getTitleKey())}</EmptyTitle>
        <EmptyDescription>{t(getDescriptionKey())}</EmptyDescription>
      </EmptyHeader>
    </Empty>
  );
};
